import { useRef } from "react";

export function useInitialPageLoad(): boolean {
  const isFirstLoad = useRef(true);

  const value = isFirstLoad.current;
  isFirstLoad.current = false;

  return value;
}